import { useEffect, useRef, useState } from 'react'
import { ISessionUseCustomMessagesTextState } from '../types'

const useCustomMessagesTextState: ISessionUseCustomMessagesTextState = currentActionState => {
  const action = currentActionState.currentActionRef.current

  const [customMessages, setCustomMessages] = useState<{ sideText: string; titleText: string; endText: string }>({
    sideText: action?.data?.survey?.side_text,
    titleText: action?.data?.survey?.resptitle,
    endText: action?.data?.survey?.end_text
  })

  const sideTextRef = useRef(customMessages.sideText)
  sideTextRef.current = customMessages.sideText

  const endTextRef = useRef(customMessages.endText)
  endTextRef.current = customMessages.endText

  const titleTextRef = useRef(customMessages.titleText)
  titleTextRef.current = customMessages.titleText

  useEffect(() => {
    const actionSideText = action?.data?.survey?.side_text
    const actionEndText = action?.data?.survey?.end_text
    const actionTitleText = action?.data?.survey?.resptitle
    if (
      actionSideText !== customMessages.sideText ||
      actionTitleText !== customMessages.titleText ||
      actionEndText !== customMessages.endText
    ) {
      setCustomMessages({
        sideText: actionSideText,
        titleText: actionTitleText,
        endText: actionEndText
      })
    }
  }, [action, customMessages])

  return { sideTextRef, titleTextRef, endTextRef } as const
}

export default useCustomMessagesTextState
